import { Component, computed, inject, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../opinion-of-conformity-of-property-division-mpzp.routes';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ArticleItem,
  OpinionOfConformityOfPropertyDivisionMpzpContentForm
} from './forms/opinion-of-conformity-of-property-division-mpzp-content.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { AlertComponent } from "../../../../../../common/alert/alert.component";

@Component({
  selector: 'app-opinion-of-conformity-of-property-division-mpzp-content-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ParcelsCrudComponent,
    ValidationErrorsComponent,
    AlertComponent
  ],
  providers: [OpinionOfConformityOfPropertyDivisionMpzpContentForm],
  templateUrl: './opinion-of-conformity-of-property-division-mpzp-content-section.component.html'
})
export class OpinionOfConformityOfPropertyDivisionMpzpContentSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: OpinionOfConformityOfPropertyDivisionMpzpContentForm = inject(OpinionOfConformityOfPropertyDivisionMpzpContentForm);

  public stages: string[] = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public get articleList(): Signal<ArticleItem[]> {
    return computed(() => {
      const app = this.application();
      if (app?.applicationSubject !== 'Wniosek o wydanie decyzji o podziale nieruchomości') {
        return [
          'Artykuł 93 ustęp 1 i ustęp 2',
          'Artykuł 93 ustęp 2a',
          'Artykuł 94',
          'Inny'
        ];
      } else {
        return [
          'Artykuł 93 ustęp 1 i ustęp 2',
          'Artykuł 93 ustęp 2a',
          'Artykuł 94',
          'Artykuł 95 punkt 1-8',
          'Inny'
        ]
      }
    })
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      const currentApp = this.application();
      if (currentApp) {
        this.store$.dispatch(
          updateParcels({
            currentApp,
            payload: this.form.toWriteModel(),
            parcels: this.form.parcelsValues,
            successFnc: (applicationId: string) => {
              this.router.navigate(
                ['../zgody'],
                {
                  relativeTo: this.route
                }
              );
            },
            failureFnc: () => {
            }
          })
        );
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
